import { render, staticRenderFns } from "./IxModuleRoot.vue?vue&type=template&id=0f2fc3c2&scoped=true&lang=html&"
import script from "./IxModuleRoot.vue?vue&type=script&lang=js&"
export * from "./IxModuleRoot.vue?vue&type=script&lang=js&"
import style0 from "./IxModuleRoot.vue?vue&type=style&index=0&id=0f2fc3c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2fc3c2",
  null
  
)

export default component.exports